module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0097.jpg?v=dc42d195";